const offerBuyLink = require('./offerLinkBuy')
const slugifyUrl = require('../slug/slugifyUrl')

module.exports = (offer) => slugifyUrl(offerBuyLink(offer, false))